module.exports = __webpack_public_path__ + "img/125-Noir Brun SFTN Mat.jpg";